var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M184.6,127.8c20.5-0.6,37.5,6.4,54.6,12.8c7.6,2.9,15.2,5.8,23.1,7.9c6.2,1.7,12.2,0.9,18.1-1.3   c10.2-3.7,20.3-7.4,30.5-11.2c17.8-6.6,36.1-11.1,55.1-9.9c35.5,2.2,65.6,16,88.5,43.9c4,4.8,3.7,5.3-1.3,8.8   c-37.1,26.1-53.3,62-48.3,106.9c4.4,39.9,25.5,68.5,61.1,86.6c4.6,2.3,5.5,4.4,3.8,9.1c-11.9,32.5-28.7,62.2-50.7,88.9   c-6.6,8-13.3,15.8-21.1,22.5c-17.5,14.9-37.3,18.2-59.4,12.4c-11.3-3-21.8-8.1-32.9-11.8c-21.4-7-42.5-5.7-63.7,1.1   c-11.1,3.6-21.6,8.5-32.9,11.6c-22,6.1-40.6,0.7-57-14.7c-27.8-26-48.4-57.1-63.8-91.6C77,374.8,68.9,348.4,64.5,321   c-5.5-33.9-5.9-67.6,4.5-100.7c8.4-27.1,22.9-50.3,45.4-67.8C135.4,136.2,159.3,127.4,184.6,127.8z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,109.8c1-31.7,14.8-57.1,38.3-77.7c17-14.9,36.9-23.5,58.9-27.6c3.4-0.6,4.8-0.1,4.9,3.7   c0.3,37.6-13.6,68.6-42.3,93c-15.5,13.2-33.2,19.7-53.5,19.9c-5,0.1-7.1-1.3-6.4-6.4C265.2,113.2,265,111.5,265,109.8z",
    fill: "#A7A7A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.32d64dffa88276a659ac7a80057ced8b.svg";
export { ForwardRef as ReactComponent };